import { Controller } from "@hotwired/stimulus"

// Sidebar del backoffice (portado de documentaweb)
export default class extends Controller {
  static targets = ["aside"]

  toggle(event) {
    event.stopPropagation()
    this.asideTarget.classList.toggle("-translate-x-full")
  }

  close(event) {
    if (this.hasAsideTarget && !this.asideTarget.contains(event.target)) {
      this.asideTarget.classList.add("-translate-x-full")
    }
  }
}
